<template>
  <el-dialog
    :model-value="modelValue"
    width="406px"
    align-center
    append-to-body
    destroy-on-close
    :show-close="false"
    :z-index="10000"
    modal-class="pc-member-success-modal-overlay bg-black/40"
    class="pc-member-success-dialog !max-w-[calc(100vw-56px)] !overflow-visible !rounded-none !bg-transparent !p-0 !shadow-none [&_.el-dialog__body]:!p-0 [&_.el-dialog__header]:hidden"
    aria-labelledby="pc-member-success-title"
    @update:model-value="updateVisible"
    @close="handleClosed"
  >
    <div class="flex w-[406px] max-w-full flex-col items-center gap-[15px]">
      <div class="relative h-[410px] w-[406px] max-w-full">
        <img
          :src="dialogBackground"
          alt=""
          aria-hidden="true"
          class="pointer-events-none absolute inset-0 h-[410px] w-[406px] max-w-full"
        />
        <span id="pc-member-success-title" class="sr-only">支付成功，您的会员已成功开通</span>

        <div
          class="absolute left-[10px] top-[113px] box-border w-[383px] rounded-[25px] border border-solid border-[#FFE9D3] bg-[#FDFBF9] px-[11px] py-[15px]"
        >
          <div
            class="h-[94px] rounded-[19px] border border-solid border-[#FFE7C0] bg-[linear-gradient(90deg,#FFF2DF_0%,#FFF4E8_52%,#FFF2DF_98%)] px-[15px] pb-[20px] pt-[15px]"
          >
            <div class="text-center  text-[15px]  leading-[22px] text-[#441D14]">
              当前会员身份
            </div>
            <div class="mt-[6px] flex items-end justify-center gap-[5px]">
              <img :src="ornamentLeft" alt="" aria-hidden="true" class="h-[28px] w-[20px] object-contain" />
              <div
                class="max-w-[240px] truncate whitespace-nowrap bg-[linear-gradient(180deg,#C57934_0%,#AB3304_100%)] bg-clip-text font-['Alimama_ShuHeiTi',sans-serif] text-[25px] font-bold leading-[28px] text-transparent"
              >
                {{ memberName }}
              </div>
              <img :src="ornamentRight" alt="" aria-hidden="true" class="h-[28px] w-[20px] object-contain" />
            </div>
          </div>

          <div class="mt-[10px] grid grid-cols-2 gap-[10px]">
            <div class="rounded-[15px] border border-solid border-[#FFE7C0] bg-[#FFF3E2] px-[10px] py-[9px] text-center">
              <div class=" text-[15px]  leading-[22px] text-[#441D14]">会员权益</div>
              <div class="mt-[2px] font-['AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular',sans-serif] text-[16px] font-medium leading-[23px] text-[#FF6B3F]">已正式生效</div>
            </div>
            <div class="rounded-[15px] border border-solid border-[#FFE7C0] bg-[#FFF3E2] px-[10px] py-[9px] text-center">
              <div class=" text-[15px]  leading-[22px] text-[#441D14]">会员有效期</div>
              <div class="mt-[2px] truncate font-['AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular',sans-serif] text-[16px] font-medium leading-[23px] text-[#FF6B3F]">{{ formattedExpireTime }}</div>
            </div>
          </div>

          <button
            type="button"
            class="mt-[18px] flex h-[56px] w-full items-center justify-center rounded-[15px] border-0 bg-[linear-gradient(90deg,#FFD9A7_0%,#FFCC88_100%)] font-['AlibabaPuHuiTi-Medium','AlibabaPuHuiTi-Regular',sans-serif] text-[19px] font-semibold leading-[19px] text-[#851A00] hover:brightness-[0.98] active:opacity-80"
            @click="confirm"
          >
            确定
          </button>
        </div>
      </div>

      <button
        type="button"
        class="flex h-[43px] w-[43px] items-center justify-center border-0 bg-transparent p-0 hover:opacity-90 active:opacity-80"
        aria-label="关闭支付成功弹框"
        @click="close"
      >
        <img :src="closeIcon" alt="" class="h-[36px] w-[36px]" />
      </button>
    </div>
  </el-dialog>
</template>

<script setup>
import { computed } from 'vue'

import closeIcon from '@/assets/images/memberSuccess/member-success-close.svg'
import dialogBackground from '@/assets/images/memberSuccess/member-success-dialog-bg-pc.png'
import ornamentLeft from '@/assets/images/memberSuccess/member-success-ornament-left.svg'
import ornamentRight from '@/assets/images/memberSuccess/member-success-ornament-right.svg'

defineOptions({ name: 'PcMemberSuccessModal' })

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  memberName: {
    type: String,
    default: '会员'
  },
  expireTime: {
    type: String,
    default: '-'
  }
})

const emit = defineEmits(['update:modelValue', 'confirm', 'close'])

const formattedExpireTime = computed(() => {
  const value = String(props.expireTime || '').trim()
  if (!value) return '-'
  return value.split(/[ T]/)[0]
})

const close = () => {
  emit('update:modelValue', false)
}

const confirm = () => {
  emit('update:modelValue', false)
  emit('confirm')
}

const updateVisible = (visible) => {
  emit('update:modelValue', visible)
}

const handleClosed = () => {
  emit('close')
}
</script>

<style>

</style>
